import VueCookies from 'vue-cookies'
import Vue from 'vue'
import App from '../components/App.vue'
import GlobalMixin from "./../app/mixins/GlobalMixin";
import makeStore from '../store/index';
import { createRouter } from '../app/router'
import { sync } from 'vuex-router-sync'
import extensions from './app/extensions';
import initFontAwesome from './app/fontAwesome'
import BootstrapVue from 'bootstrap-vue'
import GetTextPlugin from 'vue-gettext'
import translations from './../../translations/translations'
import VeeValidate from 'vee-validate'
import VueApexCharts from 'vue-apexcharts'

import "./../../scss/app.scss";

extensions()

const store = makeStore({});
const router = createRouter(store);

sync(store, router)

Vue.mixin(GlobalMixin);

Vue.use(VueCookies)

Vue.use(BootstrapVue)

Vue.use(VeeValidate)

Vue.component('apexchart', VueApexCharts)

Vue.use(GetTextPlugin, {
  availableLanguages: {
    en_US: 'English',
    sv_SE: 'Swedish'
  },
  defaultLanguage: 'sv_SE',
  translations: translations,
  silent: true
})

initFontAwesome()

const app = new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./resources/assets/js/_start/index.js